import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {BreakpointObserver} from "@angular/cdk/layout";

/** Reemplazo nativo de `isNumeric` de 'rxjs/internal-compatibility' (dependencia eliminada). */
function esNumerico(valor: any): boolean {
    return valor !== null && valor !== undefined && valor !== '' && !isNaN(Number(valor));
}

@Injectable({
    providedIn: 'root'
})
export class UtilityService {

    constructor(
        private breakpointObserver: BreakpointObserver
    ) {
    }
    static PARAM = environment.PARAM;
    HTTP_RESPONSE = environment.HTTP_RESPONSE;
    // CDN_BASE = environment.CDN_BASE;
    CDN_BASE = this.getCDNBase();

    /**
     * Validadores
     */

    public obtenerInicioDeMes() {
        const fechaActual = new Date();
        return new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    }

    verArchivo(rutaarchivo) {
        window.open(this.CDN_BASE + rutaarchivo, '_blank');
    }
    previwFile(rutaarchivo): string {
        return this.CDN_BASE + rutaarchivo;
    }

    public getPageOptions(): any[] {
        return [5, 10, 20, 30, 50, 100];
    }

    public obtenerFormatoBD(fecha) {
        return UtilityService.formatearFecha(fecha, 'yyyy-MM-DD');
    }

    public getLocationService():Promise<any> {

        const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resp => {
                resolve({lng: resp.coords.longitude, lat: resp.coords.latitude});
            }, error => {}, options);
        });
    }

    private static pad2(n: number): string {
        return n < 10 ? '0' + n : '' + n;
    }

    public static formatearFecha(fecha, formato): any {
        let fechaSeteada = "";
        if (fecha && fecha !== '-') {
            const d = UtilityService.aFechaLocal(fecha);
            fechaSeteada = d ? UtilityService.aplicarFormato(d, formato) : 'Invalid date';
        }
        return fechaSeteada;
    }

    private static aFechaLocal(fecha: any): Date | null {
        if (fecha instanceof Date) {
            return isNaN(fecha.getTime()) ? null : new Date(fecha.getTime());
        }
        if (typeof fecha === 'number') {
            return isNaN(new Date(fecha).getTime()) ? null : new Date(fecha);
        }
        if (typeof fecha === 'string') {
            const texto = fecha.trim();
            let m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(texto);
            if (m) {
                return new Date(+m[1], +m[2] - 1, +m[3]);
            }
            m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/.exec(texto);
            if (m) {
                return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
            }
        }
        const d = new Date(fecha);
        return isNaN(d.getTime()) ? null : d;
    }

    private static aplicarFormato(d: Date, formato: string): string {
        const y = d.getFullYear();
        const M = UtilityService.pad2(d.getMonth() + 1);
        const D = UtilityService.pad2(d.getDate());
        const H24 = UtilityService.pad2(d.getHours());
        const h12 = d.getHours() % 12 || 12;
        const H12 = UtilityService.pad2(h12);
        const mi = UtilityService.pad2(d.getMinutes());
        const ss = UtilityService.pad2(d.getSeconds());
        return formato.replace(/YYYY|yyyy|YY|MM|DD|HH|hh|mm|ss|A|a|L/g, (token) => {
            switch (token) {
                case 'YYYY':
                case 'yyyy': return String(y);
                case 'YY': return String(y).slice(-2);
                case 'MM': return M;
                case 'DD': return D;
                case 'HH': return H24;
                case 'hh': return H12;
                case 'mm': return mi;
                case 'ss': return ss;
                case 'A': return d.getHours() < 12 ? 'AM' : 'PM';
                case 'a': return d.getHours() < 12 ? 'am' : 'pm';
                case 'L': return M + '/' + D + '/' + y;
                default: return token;
            }
        });
    }

    public static esUnIDValido(id: string) {
        return esNumerico(id) && parseInt(id) > 0;
    }

    public static listaEstadoFiltros(): any[] {
        return [
            {"id": "-1", "value": "Todos..."},
            {"id": "1", "value": "Activos"},
            {"id": "0", "value": "Inactivos"}
        ]
    }

    public static obtenerListaDiasDeLaSemana() {
        return [
            {'value': '1', 'label': 'Lunes'},
            {'value': '2', 'label': 'Martes'},
            {'value': '3', 'label': 'Miercoles'},
            {'value': '4', 'label': 'Jueves'},
            {'value': '5', 'label': 'Viernes'},
            {'value': '6', 'label': 'Sábado'},
            {'value': '7', 'label': 'Domingo'}
        ];
    }

    /**
     * Metodo que valida si una imagen es de cloudinary para asignarle el path del CDN o no
     * @param urlImagen
     */

    public static obtenerCDNBaseImagen(urlImagen, dimensiones?) {
        if (urlImagen.startsWith('galery/')) {
            if (dimensiones) {
                return environment.CDN_CLOUDINARY + dimensiones + urlImagen;
            }
            return environment.CDN_CLOUDINARY + urlImagen;
        }
        return urlImagen;
    }

    public static jsonTranslateEspanol() {
        return {
            firstDayOfWeek: 1,
            dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
            dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
            monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
            monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
            today: 'Hoy',
            clear: 'Borrar'
        }
    }

    public static round(value, exp) {
        if (typeof exp === 'undefined' || +exp === 0) {
            return Math.round(value);
        }
        value = this.round2(value, exp + 2);
        value = +value;
        exp = +exp;
        if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
            return NaN;
        }
        value = value.toString().split('e');
        value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));
        value = value.toString().split('e');
        return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
    }

    public static round2(value, exp) {
        if (typeof exp === 'undefined' || +exp === 0) {
            return Math.round(value);
        }
        value = +value;
        exp = +exp;
        if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
            return NaN;
        }
        value = value.toString().split('e');
        value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));
        value = value.toString().split('e');
        return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
    }

    public static obtenerListaComprobantes(conTodos?) {
        let listaComprobantes = [];
        if (conTodos == this.PARAM.SI) {
            listaComprobantes.push({label: 'Todos', value: this.PARAM.TODOS, icon: 'fa fa-fw fa-book'})
        }
        listaComprobantes.push({label: 'Factura', value: 'Factura', icon: 'fa fa-fw fa-book'});
        listaComprobantes.push({label: 'Boleta', value: 'Boleta', icon: 'fa fa-fw fa-book'});
        return listaComprobantes;
    }

    public static obtenerRangofechasFormateada(listaRangoFechas) {
        let rangoFechas: any = {}
        rangoFechas.fechaInicial = this.PARAM.TODOS;
        rangoFechas.fechaFinal = this.PARAM.TODOS;
        if (Array.isArray(listaRangoFechas) && listaRangoFechas.length > 1) {
            rangoFechas.fechaInicial = UtilityService.formatearFecha(listaRangoFechas[0], 'yyyy-MM-DD 00:00:00');
            rangoFechas.fechaFinal = UtilityService.formatearFecha(listaRangoFechas[1], 'yyyy-MM-DD 23:59:59');
        }
        return rangoFechas;
    }

    public static obtenerInicioDeMes() {
        var fechaActual = new Date();
        return new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    }

    public static obtenerInicioDeMesFormatoDate() {
        const fechaActual = new Date();
        return new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    }

    public static obtenerListaIsocode(conTodos?): any[] {
        let listaIsocode = [];
        if (conTodos == this.PARAM.SI) {
            listaIsocode.push({label: 'Todos', value: this.PARAM.TODOS})
        }
        listaIsocode.push({label: 'PEN', value: 'PEN'});
        listaIsocode.push({label: 'USD', value: 'USD'});
        listaIsocode.push({label: 'EUR', value: 'EUR'});
        return listaIsocode;
    }

    public static obtenerListaEstadosOrdecompra(conTodos?) {
        let listaEstadoOrdencompra = [];
        if (conTodos == this.PARAM.SI) {
            listaEstadoOrdencompra.push({label: 'Todos', value: this.PARAM.TODOS})
        }
        listaEstadoOrdencompra.push({label: 'Anulados', value: '0'});
        listaEstadoOrdencompra.push({label: 'Nuevos', value: '1'});
        listaEstadoOrdencompra.push({label: 'Confirmados', value: '2'});
        listaEstadoOrdencompra.push({label: 'En camino', value: '3'});
        listaEstadoOrdencompra.push({label: 'Entregado', value: '4'});
        return listaEstadoOrdencompra;
    }

    public static obtenerListaEstadosInactivosActivos(conTodos?) {
        let listaEstadoOrdencompra = [];
        if (conTodos == this.PARAM.SI) {
            listaEstadoOrdencompra.push({label: 'Todas', value: this.PARAM.TODOS})
        }
        listaEstadoOrdencompra.push({label: 'Anuladas', value: '0'});
        listaEstadoOrdencompra.push({label: 'Activas', value: '1'});
        return listaEstadoOrdencompra;
    }

    public static obtenerListaMeses() {
        return [{
            label: 'Enero',
            value: 1
        }, {
            label: 'Febrero',
            value: 2
        }, {
            label: 'Marzo',
            value: 3
        }, {
            label: 'Abril',
            value: 4
        }, {
            label: 'Mayo',
            value: 5
        }, {
            label: 'Junio',
            value: 6
        }, {
            label: 'Julio',
            value: 7
        }, {
            label: 'Agosto',
            value: 8
        }, {
            label: 'Septiembre',
            value: 9
        }, {
            label: 'Octubre',
            value: 10
        }, {
            label: 'Noviembre',
            value: 11
        }, {
            label: 'Diciembre',
            value: 12
        }];
    }

    public static obtenerListaAnios() {
        const currentAnio = (new Date()).getFullYear();
        let anioList = [];
        for (let i = 2016; i < currentAnio; i++) {
            anioList.push({"value": i, "label": i});
        }
        anioList.push({"value": currentAnio, "label": currentAnio});
        for (let i = currentAnio + 1; i <= 2040; i++) {
            anioList.push({"value": i, "label": i});
        }

        return anioList;
    }

    public static obtenerListaUbicacionesPagina() {
        let listaUbicacionesPagina = [];
        listaUbicacionesPagina.push({label: 'Header', value: '1'});
        listaUbicacionesPagina.push({label: 'Footer', value: '2'});
        return listaUbicacionesPagina;
    }


    public validarInputSearch(busqueda) {
        if (busqueda != undefined && busqueda != null && busqueda != "") {
            if (!Number.isNaN(busqueda)) {
                return busqueda;
            } else {

                var texto = busqueda.replace(/[^\w\s]/gi, '');
                if (texto == '') {
                    return UtilityService.PARAM.TODOS;
                }
                return texto;
            }

        }
        return UtilityService.PARAM.TODOS;
    }

    public esNumero(value): boolean
    {
        return ((value != null) &&
            (value !== '') &&
            !isNaN(Number(value.toString())));
    }

    /**
     * Parsers data
     */
    public parseData(data, tablaDescripcion?: string, tablaId?: string): any {
        let dataObj = {tipo: this.HTTP_RESPONSE.MALFORMED_JSON, mensajes: ['JSON mal formado', data], data: null};
        if (data !== null && typeof data === 'object') {
            if (data.data !== null && typeof data.data === 'object') {
                dataObj = data;
                if (!data.tipo) {
                    dataObj.tipo = this.HTTP_RESPONSE.SUCCESS;
                }
            } else {
                /**
                 * Si la respuesta es pura sin tipo ni mensajes seteo data a la respuesta
                 */
                if (data.data && data.tipo && data.mensajes) {
                    dataObj = data;
                } else {
                    if (!data.tipo && !data.mensajes) {
                        dataObj = {tipo: this.HTTP_RESPONSE.SUCCESS, mensajes: [], data};
                        if (data.mensajes && Array.isArray(data.mensajes)) {
                            dataObj = {tipo: this.HTTP_RESPONSE.SUCCESS, mensajes: data.mensajes, data};
                        }
                        if (data.mensajes && !Array.isArray(data.mensajes)) {
                            dataObj = {tipo: this.HTTP_RESPONSE.SUCCESS, mensajes: [data.mensajes], data};
                        }
                    } else {
                        if (data.tipo === this.HTTP_RESPONSE.PERMISION_ERROR) {
                            dataObj = data;
                        }
                        if (data.tipo === this.HTTP_RESPONSE.SUCCESS) {
                            if (data.mensajes && Array.isArray(data.mensajes)) {
                                dataObj = {tipo: data.tipo, mensajes: data.mensajes, data};
                            } else {
                                dataObj = {tipo: data.tipo, mensajes: [data.mensajes], data};
                            }
                        }
                        if (data.tipo === this.HTTP_RESPONSE.WARNING) {
                            if (data.mensajes && Array.isArray(data.mensajes)) {
                                dataObj = {tipo: data.tipo, mensajes: data.mensajes, data};
                                dataObj = {tipo: data.tipo, mensajes: data.mensajes, data};
                            } else {
                                dataObj = {tipo: data.tipo, mensajes: [data.mensajes], data};
                            }
                        }
                        if (data.tipo === this.HTTP_RESPONSE.INFO) {
                            if (data.mensajes && Array.isArray(data.mensajes)) {
                                dataObj = {tipo: data.tipo, mensajes: data.mensajes, data};
                            } else {
                                dataObj = {tipo: data.tipo, mensajes: [data.mensajes], data};
                            }
                        }
                        if (data.tipo === this.HTTP_RESPONSE.ERROR) {
                            if (data.mensajes && Array.isArray(data.mensajes)) {
                                /**
                                 * Si la respuesta tiene alguno de los siguientes problemas parseo
                                 * la respuesta indicando el origen del problema
                                 */
                                    // tslint:disable-next-line:max-line-length
                                const mensajeServidorError = this.parseResponseErrorDatabase(data.mensajes, tablaDescripcion, tablaId);
                                dataObj = {tipo: data.tipo, mensajes: mensajeServidorError, data};
                            } else {
                                dataObj = {tipo: data.tipo, mensajes: [data.mensajes], data};
                            }
                        }
                    }
                }
            }
        }
        return dataObj;
    }

    public parseResponseErrorDatabase(mensajes: any[], tablaDescripcion: string, tablaId: string) {
        let mensajeArrayProcesada = [];

        mensajes.forEach(error => {
            /**
             * Pregunto si el error es por algun fk delete
             */
            if (error.includes('Cannot delete or update a parent row: a foreign key constraint fails')) {
                // tslint:disable-next-line:max-line-length
                mensajeArrayProcesada.push('El elemento con ID "' + tablaId + '" de la tabla "' + tablaDescripcion + '" está referenciado en otra(s) tabla(s), ' +
                    'por favor contacta al admininistrador para notificar el problema e ' +
                    'indicale el id y la tabla que tienen problemas.');
            }
        });

        if (!mensajeArrayProcesada.length) {
            mensajeArrayProcesada = mensajes;
        }

        return mensajeArrayProcesada;
    }

    /**
     * Formatos de fecha
     */
    public obtenerFechaActual(): any {
        return UtilityService.formatearFecha(new Date(), 'L');
    }

    public obtenerFechaHoraActual(): any {
        // Antes: format('YYYY-MM-DD HH:MM:SS') con moment, donde MM = mes y SS = centésimas:
        // devolvía el mes en la posición de minutos y '00' en segundos. Se corrige a minutos/segundos reales.
        return UtilityService.formatearFecha(new Date(), 'YYYY-MM-DD HH:mm:ss');
    }

    public obtenerListaBloquePanelimagen(): any {
        return [
            {
                id: '0',
                value: 'Bloque ofertas (Superior)'
            },
            {
                id: '1',
                value: 'Bloque ofertas (Inferior)'
            },
            {
                id: '2',
                value: 'Bloque productos por identificador'
            }
        ];
    }

    public obtenerListaColumnasBloquePanelimagen(): any {
        return [
            {
                id: '1',
                value: 'Ocupa 1 columna'
            },
            {
                id: '2',
                value: 'Ocupa 2 columnas'
            },
            {
                id: '3',
                value: 'Ocupa 3 columnas'
            },
            {
                id: '4',
                value: 'Ocupa 4 columna'
            },
            {
                id: '5',
                value: 'Ocupa 5 columnas'
            },
            {
                id: '6',
                value: 'Ocupa 6 columnas'
            },
            {
                id: '7',
                value: 'Ocupa 7 columna'
            },
            {
                id: '8',
                value: 'Ocupa 8 columnas'
            },
            {
                id: '9',
                value: 'Ocupa 9 columnas'
            },
            {
                id: '10',
                value: 'Ocupa 10 columna'
            },
            {
                id: '11',
                value: 'Ocupa 11 columnas'
            },
            {
                id: '12',
                value: 'Ocupa 12 columnas'
            }
        ];
    }

    public obtenerPaletaColores(): any {
        return [
            {"id": "1", "color": "#000000"},
            {"id": "2", "color": "#2E64FE"},
            {"id": "3", "color": "#DF0101"},
            {"id": "4", "color": "#088A4B"},
            {"id": "5", "color": "#FF0080"},
            {"id": "6", "color": "#FA5858"},
            {"id": "7", "color": "#086A87"},
            {"id": "8", "color": "#FA5882"},
            {"id": "9", "color": "#DBA901"},
            {"id": "10", "color": "#2E9AFE"},
            {"id": "11", "color": "#EE7115"},
            {"id": "12", "color": "#20D860"},
            {"id": "13", "color": "#D779D4"},
            {"id": "14", "color": "#C77557"},
            {"id": "15", "color": "#F6E10C"},
        ]
    }

    public ubicarPuntoCentralDentroDeAreaEspecifica(array_points) {

        let puntoCentral = {
            latitud: null,
            longitud: null,
        };

        let latitudMin = array_points[0].latitude * 1;
        let longitudMin = array_points[0].longitude * 1;

        let latitudMax = array_points[0].latitude * 1;
        let longitudMax = array_points[0].longitude * 1;

        for (let i = 0; i < array_points.length; i++) {

            let point = array_points[i];

            if (latitudMin < point.latitude * 1) {
                latitudMin = point.latitude * 1;
            }
            if (latitudMax > point.latitude * 1) {
                latitudMax = point.latitude * 1;
            }

            if (longitudMin < point.longitude * 1) {
                longitudMin = point.longitude * 1;
            }
            if (longitudMax > point.longitude * 1) {
                longitudMax = point.longitude * 1;
            }
        }

        puntoCentral.latitud = (latitudMin + latitudMax) / 2;
        puntoCentral.longitud = (longitudMin + longitudMax) / 2;

        return puntoCentral;
    }

    public cantidadMaximaDigitosInputs() {
        return 9;
    }

    public formatoNumero(amount, decimales?) {
        const respaldo = amount;
        const decimals = Number(decimales) >= 0 ? decimales : 2;
        amount += '';
        if (amount === 'NaN' || amount === 'undefined' || amount === 'Infinity') {
            amount = '0';
        }
        if (isNaN(amount)) {
            return respaldo;
        }

        amount = parseFloat(amount); // convierte a numero
        amount = UtilityService.round(amount, decimals); // devuelve un string
        const codIdioma = this.obtenerIdiomaLocal();
        amount = (amount).toLocaleString(codIdioma, {minimumFractionDigits: decimals}); // retorna string
        return amount;
    }

    public obtenerIdiomaLocal() {
        // const localStorage = SecurityService.obtenerLocalActual();
        // if (localStorage) {
        //    return localStorage.local_idioma;
        //}
        return 'en-IN';
    }

    public obtenerFormatoVistaAMPM(fecha) {
        return UtilityService.formatearFecha(fecha, 'DD/MM/yyyy') + ' ' + UtilityService.formatearFecha(fecha, 'hh:mm A');
    }

    public obtenerFormatoVistaDiaMes(fecha) {
        return UtilityService.formatearFecha(fecha, 'DD/MM');
    }

    public obtenerFormatoVistaDDMMYYY(fecha) {
        return UtilityService.formatearFecha(fecha, 'DD/MM/yyyy');
    }

    public obtenerFormatoVistaHora(fecha) {
        return UtilityService.formatearFecha(fecha, 'hh:mm A');
    }

    public obtenerAnioActual() {
        return new Date().getFullYear();
    }

    public obtenerPrecintoAduanaFinal(ordenServicio) {
        let precintoFinal = ordenServicio.ordenservicio_precintoaduana;

        if (ordenServicio.ordenservicio_precintoadicional2) {

            precintoFinal = ordenServicio.ordenservicio_precintoadicional2nombre;

        } else if (ordenServicio.ordenservicio_precintoadicional1) {

            precintoFinal = ordenServicio.ordenservicio_precintoadicional1nombre;

        } else if (ordenServicio.ordenservicio_precintofinal) {

            precintoFinal = ordenServicio.ordenservicio_precintofinal;

        }

        return precintoFinal;
    }

    public obtenerNombreTipoEmbarque(tipoembarque, nombreLargo = false) {
        let txt = "";
        switch (tipoembarque) {
            case '1':
                txt = nombreLargo ? "LOCAL DE EXPORTADOR" : "LEX";
                break;
            case '2':
                txt = nombreLargo ? "DEPOSITO TEMPORAL / ALEATORIO" : "DT";
                break;
            case '3':
                txt = nombreLargo ? "DEPOSITO TEMPORAL / ALEATORIO" : "AF. SINI";
                break;
        }
        return txt;

    }

    public obtenerNombreCanal(canal) {
        let txt = "";
        switch (canal) {
            case '1':
                txt = "ROJO";
                break;
            case '2':
                txt = "VERDE";
                break;
            default:
                txt = "SIN CANAL";
                break;
        }
        return txt;

    }

    public getPesoVGM(taraContenedor: number, pesoBruto: number) {
        return Number(taraContenedor) + Number(pesoBruto);
    }

    public getTaraCamion(pesocamion, pesoBruto) {
        if (pesocamion * 1 > pesoBruto * 1)
            return pesocamion - pesoBruto;
        else
            return 0;
    }

    public isMobile(){
        return  this.breakpointObserver.isMatched('(max-width: 768px)');

    }

    public contiene(cadena: any, subcadena: any): boolean {
        let contiene = false;
        if (cadena.indexOf(subcadena) !== -1) {
            contiene = true;
        }
        return contiene;
    }

    public getCDNBase(){
        // return //localhost/asistenciaapi/";
        /*if (this.contiene(this.getSubdomain(), ".qa")){
            return '//rrhh.api.qa.' + this.getDomain() + "/";
        }else{
            return '//asistenciaapi.' + this.getDomain() + "/";
        }*/
        return environment.CDN_BASE;
    }

    public getURLBaseApi(){
        // return this.getURLBase() + "/api/rest/";
        return environment.API_URI;
    }

    public getURLBasePublic(){
        // return this.getURLBase() + "/public/rest/";
        return environment.PUBLIC_URI;
    }


}

